/* eslint-disable class-methods-use-this */
import { apiBaseUrl, apiEndpoints } from './constants';

export default class ApiController {
    static instance;
    #baseUrl = apiBaseUrl;
    #apiToken;
    #sessionToken;

    constructor() {
        if (ApiController.instance) {
            // eslint-disable-next-line no-constructor-return
            return ApiController.instance;
        }

        ApiController.instance = this;
    }

    set sessionToken(token) {
        this.#sessionToken = token;
    }

    async makeRequest(url, method = 'GET', data = {}) {
        const skipTokenCheck = url === apiEndpoints.GET_TOKEN;

        if (!this.#apiToken && !skipTokenCheck) {
            await this.getApiToken();
        }

        if (this.#sessionToken) {
            data['session-token'] = this.#sessionToken;
        }

        const result = {
            data: null,
            error: null
        };

        const requestParams = {
            method,
            // credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        };

        if (this.#apiToken) {
            requestParams.headers.Authorization = `Bearer ${this.#apiToken}`;
        }

        let requestUrl = `${this.#baseUrl}${url}`;

        switch (method) {
            case 'GET':
                requestUrl = `${requestUrl}?${new URLSearchParams(data).toString()}`;

                break;
            default: {
                requestParams.body = JSON.stringify(data);
            }
        }

        try {
            const response = await fetch(requestUrl, {
                ...requestParams
            });

            const contentType = response.headers.get('content-type');
            let responseData;
            let responseText;

            if (contentType.indexOf('json') !== -1) {
                responseData = await response.json();
            } else {
                responseText = response.text();
            }

            if (response.status !== 200) {
                if (responseData) {
                    result.error = {
                        status: response.status,
                        text: response.statusText || responseData.error || responseData.message,
                        validationErrors: responseData.errors
                    };
                } else {
                    result.error = {
                        messageToShow: 'Ошибка. Попробуйте обновить страницу.'
                    };
                }

            } else {
                // const responseData = await response.json();

                if (responseData?.token) {
                    this.#apiToken = responseData.token;
                }

                result.data = responseData || responseText;
            }

        } catch (e) {
            console.log(e);
            result.error = {
                messageToShow: 'Ошибка. Попробуйте обновить страницу.'
            };
        }

        return result;
    }

    async register(userData) {
        const response = await this.makeRequest(apiEndpoints.REGISTER, 'POST', { ...userData });

        return response;
    }

    async login(loginData) {
        const response = await this.makeRequest(apiEndpoints.LOGIN, 'POST', { ...loginData });

        return response;
    }

    async logout() {
        const response = await this.makeRequest(apiEndpoints.LOGOUT, 'POST');

        return response;
    }

    async resetPassword(data) {
        const response = await this.makeRequest(apiEndpoints.RESET_PASSWORD, 'POST', { ...data });

        return response;
    }

    async setNewPassword(data) {
        const response = await this.makeRequest(apiEndpoints.SET_NEW_PASSWORD, 'POST', { ...data });

        return response;
    }

    async getApiToken() {
        const response = await this.makeRequest(apiEndpoints.GET_TOKEN, 'GET', {
            email: 'fun_express@yandex.ru',
            password: 'password'
        });

        return response;
    }

    async authByToken() {
        const response = await this.makeRequest(apiEndpoints.AUTHORIZE, 'POST');

        return response;
    }

    async getUserData(id) {
        const url = `${apiEndpoints.GET_USER_DATA}/${id}`;
        const response = await this.makeRequest(url, 'GET');

        return response;
    }

    async fetchLevelConfig() {
        const response = await this.makeRequest(apiEndpoints.FETCH_LEVEL_CONFIG, 'POST');

        return response;
    }

    async uploadResult(data) {
        const response = await this.makeRequest(apiEndpoints.UPLOAD_RESULT, 'POST', { ...data });

        return response;
    }

    async fetchLeaderboard(data) {
        const response = await this.makeRequest(apiEndpoints.GET_LEADERBOARD, 'GET', { ...data });

        return response;
    }

    async getIsUserLogged() {
        const response = await this.makeRequest(apiEndpoints.GET_IS_USER_LOGGED, 'POST');

        return response;
    }

    async getGameSessionData(id) {
        const url = `${apiEndpoints.GET_GAME_SESSION_DATA}/${id}`;
        const response = await this.makeRequest(url, 'GET');

        return response;
    }
}
